import { Heatmap } from "../../../@types/visualization";
import { htmlEncode } from "../../../util";

type Props = {
  heatmap: Array<Heatmap>;
  onMouseEnter: (className: string) => void;
  onMouseLeave: () => void;
};

const EntropyMenuList = ({ heatmap, onMouseEnter, onMouseLeave }: Props) => (
  <>
    {heatmap.map((element: Heatmap, index: number) => {
      const machineName = `entropy-${element.style}`;
      return (
        <li
          className={machineName}
          onMouseEnter={() => onMouseEnter(machineName)}
          onMouseLeave={onMouseLeave}
          key={index}
        >
          <div className={machineName}></div>
          <span>{htmlEncode(element.name)}</span>
        </li>
      );
    })}
  </>
);

export default EntropyMenuList;
